import logoIMG from '@/assets/imgs/brand/logo.png';
import essentialIMG from '@/assets/imgs/cards/essential.png';
import premiumIMG from '@/assets/imgs/cards/premium.png';
// import card1IMG from '@/assets/imgs/cards/bg1.png';
// import card2IMG from '@/assets/imgs/cards/bg2.png';
// import card3IMG from '@/assets/imgs/cards/bg3.png';
import appleWalletIMG from '@/assets/imgs/logos/apple-wallet.svg';
import googleWalletIMG from '@/assets/imgs/logos/google-wallet.png';
import { SUPPORTED_CHAINS } from '@package/smart-wallet/constants';

export const MID_SIZE_ADDRESS_LENGTH = 12;

// Re-export NETWORKS for backwards compatibility, filtering out testnet chains
export const NETWORKS: {
  label: string;
  id: number;
  icon: string;
  nativeIcon: string;
}[] = Object.entries(SUPPORTED_CHAINS)
  .filter(([chainId]) => Number(chainId) !== 97) // Exclude testnet
  .map(([chainId, config]) => ({
    label: config.label,
    id: Number(chainId),
    icon: config.icon,
    nativeIcon: config.nativeIcon,
  }));

export const navigation = [
  {
    title: 'Wallet',
    icon: 'dashboard',
    href: '/dashboard',
  },
  {
    title: 'Cards',
    icon: 'product-think',
    list: [
      {
        title: 'My Cards',
        href: '/cards',
      },
      {
        title: 'Order New Card',
        href: '/cards/new',
      },
    ],
  },
  {
    title: 'Profile',
    icon: 'edit-profile',
    href: '/profile',
  },
  {
    title: 'Referral',
    icon: 'promote',
    href: '/referral',
  },
  {
    title: 'FAQ',
    icon: 'info',
    href: '/faq',
  },
  {
    title: 'Verification Issues',
    icon: 'chat',
    href: '/help/verification-issues',
    disable: true,
  },
  {
    title: 'Terms & Conditions',
    icon: 'envelope',
    href: '/terms',
  },
];

export const navigationUser = [
  {
    title: 'Edit profile',
    icon: 'edit-profile',
    href: '/settings',
  },

  {
    title: 'Affiliate center',
    icon: 'chain-think',
    href: '/affiliate-center',
  },
  {
    title: 'Explore creators',
    icon: 'grid',
    href: '/explore-creators',
  },
];

export const temporaryNameCards = {
  0: {
    name: '--',
    img: logoIMG,
  },
  111040: {
    name: '--',
    img: logoIMG,
  },
  111028: {
    name: 'Apple Pay',
    img: appleWalletIMG,
  },
  111033: {
    name: 'Google Pay',
    img: googleWalletIMG,
  },
};
type Tier = {
  img: string;
  id: number;
  annualPrice: number;
  features: string[];
  spendingLimit?: number;
  xtravelerPoints?: number;
  customerSupport?: string;
};

export const TIER_DATA: Record<string, Tier> = {
  'MANUM': {
    img: premiumIMG,
    id: 1,
    annualPrice: 50,
    spendingLimit: 200000,
    features: [
"Control total desde tu wallet: recarga y usa tu saldo cuando quieras (hasta $200.000)", 
"Comisión por recarga: 5% transparente y sin sorpresas",
"Tarjeta virtual instantánea: más seguridad para comprar online",
"Pagos móviles habilitados: Apple Pay y Google Pay",
"Aceptación online amplia: compras y suscripciones sin complicaciones",
"Atención prioritaria: soporte rápido y personalizado",

     ],
    xtravelerPoints: 100,
    customerSupport: 'Exclusive Customer Support',
  },
  'ESSENTIAL': {
    img: essentialIMG,
    id: 2,
    annualPrice: 30,
    spendingLimit: 100000,
    features: [
"Control total desde tu wallet: recarga y usa tu saldo cuando quieras (hasta $100.000)", 
"Comisión por recarga: 6,5% transparente y sin sorpresas",
"Tarjeta virtual instantánea: más seguridad para comprar online",
"Pagos móviles habilitados: Apple Pay y Google Pay",
"Aceptación online amplia: compras y suscripciones sin complicaciones",
"Atención prioritaria: soporte rápido y personalizado",
     ],
    xtravelerPoints: 100,
    customerSupport: 'Exclusive Customer Support',
  },
};

// Function that can be called as temporaryTiers('Tier 1') or temporaryTiers(1)
// Also preserves object-like property access: temporaryTiers['Tier 1']
const DEFAULT_TIER = TIER_DATA['MANUM'];

function temporaryTiersFn(key?: string | number) {
  if (typeof key === 'number') {
    const found = Object.values(TIER_DATA).find((t) => t.id === key);
    return found ?? DEFAULT_TIER;
  }
  if (typeof key === 'string') {
    return TIER_DATA[key] ?? DEFAULT_TIER;
  }
  return TIER_DATA;
}

const handler: ProxyHandler<typeof temporaryTiersFn> = {
  // allow calling the proxy as a function
  apply(target, _thisArg, args) {
    return target(...(args as [string | number | undefined]));
  },
  // intercept property access: temporaryTiers['Tier 1'] and temporaryTiers.PROP
  get(target, prop) {
    // existing properties on the function (if any)
    if (prop in target) {
      return (target as any)[prop];
    }

    // string property access: check tier keys
    if (typeof prop === 'string') {
      if (prop in TIER_DATA) return TIER_DATA[prop];
      if (prop === 'byId')
        return (id: number) =>
          Object.values(TIER_DATA).find((t) => t.id === id) ?? DEFAULT_TIER;
      if (prop === 'all') return () => TIER_DATA;
      // if not found, return default tier
      return DEFAULT_TIER;
    }

    // fallback
    return (target as any)[prop];
  },
};

export const temporaryTiers = new Proxy(temporaryTiersFn, handler) as any;
